import { useNavigate } from "react-router-dom";
import { Menu, Box, Button, Flex } from "@chakra-ui/react";

import { ISubCategory } from "interfaces/categories/ICategory";
import { useAuth } from "hooks/useAuth";

import { MenuButtonHeader } from "components/MenuButtonHeader";
import { useContext, useEffect, useState } from "react";
import api from "services/api";
import { Context as ContextActivated } from '../../../contexts/activated';

interface SubCategoryProps extends ISubCategory {
    subCategoryChildrenName?: string;
    subCategoryChildrenId?: number;
    subCategoriaId?: number;
    isChildren?: boolean;
    categoriaSelecionadaId?: number;
    uri?: string;
    uriPai?: string;
    uriFilho?: string;
}

interface SubMenuCategoriesProps extends ISubCategory {
    subCategories: SubCategoryProps[];
    handleShowMenuList: (categoryId: number) => void;
    arrowIcon: any;
    setIsArrowDown: (value: boolean) => void;
    isArrowDown: boolean;
    categoryIdRef: any;
    categoryRefName: any;
    categoriaSelecionada: any;
    handleCloseMenu: () => void;
}

let todos = false

export const MenuCategoriesMobile = ({
    subCategories,
    handleShowMenuList,
    arrowIcon,
    setIsArrowDown,
    isArrowDown,
    categoriaSelecionada,
    categoryIdRef,
    categoryRefName,
    handleCloseMenu,
}: SubMenuCategoriesProps) => {
    const navigate = useNavigate();
    const { user, signOut } = useAuth();
    const [saldoPromotora, setSaldoPromotora] = useState<number | string>(0);
    const [isPromotora, setIsPromotora] = useState<boolean>(false);
    const [subCategoriesState, setSubCategoriesState] = useState<any>(
        {
            showDiscounts: false,
            subCategories: subCategories ?? []
        });

    const [stateActivated, dispatchActivated] = useContext<any>(ContextActivated);
    const [quantityActivated, setQuantityActivated] = useState<number>(0);
    const [showPointsMenu, setShowPointsMenu] = useState<boolean>(true);

    useEffect(() => {
        verifyHaveCartActive()
    }, [])

    useEffect(() => {
        setQuantityActivated(stateActivated.quantidade)
    }, [stateActivated])

    useEffect(() => {
        checkPromotora()
    }, [])

    useEffect(() => {
        setSubCategoriesState({
            showDiscounts: subCategoriesState?.showDiscounts && subCategoriesState?.showDiscounts,
            subCategories: subCategories ?? []
        })
    }, [subCategories])

    const verifyHaveCartActive = async () => {
        let { data } = await api.get("/motorDePontos/consultarCarrinhoAtivo");
        if (data.length > 0) {
            dispatchActivated({ type: "UPDATE_QUANT_ACTIVATED", quantidade: data.length })
            setQuantityActivated(data.length)
        } else {
            dispatchActivated({ type: "UPDATE_QUANT_ACTIVATED", quantidade: 0 })
        }
    }

    function handleSignOut() {
        signOut();
        navigate("/");
    }

    const changeStateCategoriesOpen = () => {

        let response
        let data = { ...subCategoriesState }

        if (todos && !subCategoriesState.showDiscounts) {
            response = {
                showDiscounts: false,
                subCategories: subCategories ?? []
            }
            setSubCategoriesState(response)
            return
        }

        if (data?.showDiscounts == true) {
            response = {
                showDiscounts: !data?.showDiscounts,
                subCategories: subCategories ?? []
            }
            setSubCategoriesState(response)
        } else {
            response = {
                showDiscounts: true,
                subCategories: subCategories ?? []
            }
            setSubCategoriesState(response)
        }

    }

    const checkPromotora = async () => {
        let userStorage: any = localStorage.getItem('@FPontos:user');
        userStorage = JSON.parse(userStorage)
        if (userStorage?.promotora == true) {
            setIsPromotora(true)
            const response = await api.get('/pontuacao/saldo/promotora');
            setSaldoPromotora(response.data.saldo)
        } else {
            setIsPromotora(false)
        }
    }

    function handleCategory({
        uri,
        uriPai,
        uriFilho,
        categoriaSelecionadaId,
        descricao,
        categoriaId,
        categoriaPaiId,
        subCategoryChildrenName,
        subCategoryChildrenId,
        isChildren,
    }: SubCategoryProps) {

        var url = `/categoria/${uriPai}`;
        if (uri) { url += `/${uri}` }
        if (uriFilho) { url += `/${uriFilho}` }

        var subCategoriasSelected = subCategories.filter(x => x.uri === uri)
        var subs;

        if (subCategoriasSelected.length > 0) {
            subs = subCategoriasSelected[0].subCategoriaFilho
        }

        navigate(url, {
            // navigate(`/categoria`, {
            state: {
                uri: uri,
                uriPai: uriPai,
                uriFilho: uriFilho,
                categorias: subs,
                subCategoriesPai: categoriaSelecionada?.subCategoria,
                subCategories: subs,
                categoriaSelecionadaId,
                categoriaSelecionadaNome: descricao,
                categoriaSelecionadaPai: categoriaSelecionada?.descricao
                // categoriaId: subCategoryChildrenId
                //   ? subCategoryChildrenId
                //   : categoriaPaiId,
                // categoriaName: categoryRefName,
                // subCategoryName: descricao,
                // subCategoryId: categoriaId,
                // subCategoryChildrenName,
                // subCategoryChildrenId,
                // cleanSubCategoryId: true,
                // isChildren,
            },
        });
        handleCloseMenu();
    }

    return (
        <Box position="relative" width="100%">
            <Menu>
                <MenuButtonHeader
                    name="Home"
                    onClick={() => {
                        navigate("/home");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Produtos"
                    onClick={() => {
                        navigate("/categoria");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Extrato de pontos"
                    onClick={() => {
                        navigate("/extrato-de-pontos");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Novo Resgate"
                    onClick={() => {
                        navigate("/resgate-pix");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Extrato de resgates"
                    onClick={() => {
                        navigate("/extrato-resgate");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            {user?.extendedData?.atendente === "true" &&
            <Menu>
                <MenuButtonHeader
                    name="Ranking Vitaderm"
                    onClick={() => {
                        navigate("/ranking-atendimento");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            }
            <Menu>
                <MenuButtonHeader
                    name="Mapa da Lojas"
                    onClick={() => {
                        navigate("/por-perto");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Benefícios"
                    onClick={() => {
                        navigate("/beneficios");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Meus Dados"
                    onClick={() => {
                        navigate("/meus-dados");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Meus amigos"
                    onClick={() => {
                        navigate("/meus-amigos");
                        handleCloseMenu();
                    }}
                />
            </Menu>
            <Menu>
                <MenuButtonHeader
                    name="Alterar senha"
                    onClick={() => {
                        navigate("/alterar-senha");
                        handleCloseMenu();
                    }}
                />
            </Menu>

            <Flex marginTop={10} alignItems="center" justifyContent="center">
                <Button
                    backgroundColor="#EC1C24"
                    textAlign="center"

                    fontSize="18px"
                    fontWeight="semibold"
                    color="#FFFF"
                    _hover={{ backgroundColor: "transparent" }}
                    _active={{ backgroundColor: "transparent" }}
                    _focus={{ backgroundColor: "transparent" }}
                    onClick={() => handleSignOut()}
                >
                    Sair
                </Button>
            </Flex>
        </Box>
    );
};
